import { React } from "react";
import UserPhoto from "../../../Assets/profile.png";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import backgroundImage from '../../../Assets/images/others/profile_heade_background.png';
import Facebook from "../../../Assets/Svg/facebook2.svg";
import Instagram from "../../../Assets/Svg/instagram2.svg";
import Telegram from "../../../Assets/Svg/Telegram2.svg";
import Whatsapp from "../../../Assets/Svg/Whatsapp.svg";
import Skype from "../../../Assets/Svg/skype.svg";
import Tiktok from "../../../Assets/Svg/tiktok.svg";
import Box from "@mui/material/Box";
import Files from "react-files";

const ProfileHeader = ({ editedProfile,isEditing,handleFileChange,handleFileError }) => { // Receive editedProfile as a prop
    const profileData = useSelector((state) => state.profile.profileData);

    return (
        <>
            <div className={'header-background'} style={{
                backgroundImage: `linear-gradient(90deg, rgba(53, 125, 171, 0.3) 0%, rgba(23, 55, 76, 0.3) 100%), url(${backgroundImage})`,

            }}>
                <div className={'d-flex align-items-center profile-header-container'}>
                    <div className={'profile-avatar-div'}>
                        <img
                            src={
                                editedProfile?.photoPreview || profileData?.photo || UserPhoto
                            }
                            alt="UserPhoto"
                            className={'profile-avatar'}
                        />
                        {isEditing && (
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "white",
                                }}
                            >
                                <Files
                                    onChange={handleFileChange}
                                    onError={handleFileError}
                                    accepts={["image/*"]}
                                    multiple={false}
                                    clickable
                                >
                                    Click to Upload
                                </Files>
                            </Box>
                        )}



                    </div>
                    <div className={'profile-information'}>
                        <Typography className={'profile-header-name'}>
                            {profileData?.name}
                        </Typography>
                        <Typography className={'profile-header-location'}>
                            {profileData?.name}
                        </Typography>
                        {
                            profileData?.about &&
                            <Typography className={'lead quoted-text'}>
                                {profileData?.about}
                            </Typography>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProfileHeader;
